import { DatePipe } from '@angular/common';
import { Component, effect, output, signal } from '@angular/core';

import { TranslatePipe } from '@camelot/translation';
import { ButtonToolComponent } from '@camelot/ui';

import { CamTranslationCalendar } from '../../../translation.service';
import { SchedulerModeSetup } from '../../../types/scheduler';
import { AbstractSchedulerComponent } from '../../abstract-scheduler.component';

@Component({
  selector: 'cam-calendar-scheduler-header',
  imports: [ButtonToolComponent, DatePipe, TranslatePipe],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class CamCalendarSchedulerHeaderComponent extends AbstractSchedulerComponent {
  mapToggle = output<boolean>();

  readonly mapOpened = signal(false);

  readonly modeList = signal<SchedulerModeSetup[]>([
    {
      translation: 'calendar.scheduler.header.hourAndDay',
      duration: 1,
      viewPreset: {
        base: 'hourAndDay',
        tickWidth: 60,
        timeResolution: {
          unit: 'minute',
          increment: 15,
        },
      },
    },
    {
      translation: 'calendar.scheduler.header.manyHourAndDay',
      duration: 3,
      default: true,
      viewPreset: {
        base: 'hourAndDay',
        tickWidth: 60,
        timeResolution: {
          unit: 'minute',
          increment: 15,
        },
      },
    },
    {
      translation: 'calendar.scheduler.header.dayAndWeek',
      duration: 6,
      viewPreset: {
        base: 'dayAndWeek',
        tickWidth: 45,
        timeResolution: {
          unit: 'minute',
          increment: 15,
        },
      },
    },
    {
      translation: 'calendar.scheduler.header.weekAndDayLetter',
      duration: 30,
      viewPreset: {
        base: 'weekAndDayLetter',
        tickWidth: 45,
        timeResolution: {
          unit: 'minute',
          increment: 15,
        },
      },
    },
  ]);
  constructor() {
    super();
    CamTranslationCalendar.getInstance();
    effect(() => {
      this.mapToggle.emit(this.mapOpened());
    });
  }

  override ngOnInit() {
    super.ngOnInit();
    this._registerSubscription(
      this.getIsReady$().subscribe({
        next: () => {
          const defaultMode = this.modeList().find(mode => mode.default);
          if (defaultMode) {
            this.changeMode(defaultMode);
          }
        },
      })
    );
  }

  public currentMode() {
    return this._scheduler.currentMode();
  }

  public date() {
    const activeView = this._scheduler.api?.span();
    if (!activeView) {
      return null;
    }
    return {
      start: activeView.startDate ?? null,
      end: activeView.endDate ?? null,
    };
  }
  public changeMode(mode: SchedulerModeSetup) {
    if (!this._scheduler.api) {
      return;
    }

    this._scheduler.setMode(mode);
  }

  public goToToday() {
    this._scheduler.api?.setStartDate(new Date());

    const currentMode = this.currentMode();
    if (currentMode) {
      this._scheduler.setMode(currentMode);
    }
  }

  public goToNext() {
    this._scheduler.api?.shiftNext();
  }

  public goToPrevious() {
    this._scheduler.api?.shiftPrevious();
  }

  public toggleMap() {
    this.mapOpened.set(!this.mapOpened());
  }
}
